<script>
export default {
  name: 'TwCard',
  props: {
    size: {
      type: String,
      default: 'md'
    }
  },
  computed: {
    containerClasses() {
      return {
        'px-4 py-6 sm:p-6': this.size === 'md',
        'p-4': this.size === 'sm',
        'px-6 py-7 sm:px-8 sm:py-9': this.size === 'lg'
      }
    }
  }
}
</script>

<template>
  <div :class="['rounded-xl shadow', containerClasses]">
    <slot />
  </div>
</template>

<style scoped>

</style>
